// Answers a download gives its reason in: the file cannot be set, the line is full, it took too long.
const TELLS_WHY = new Set([422, 429, 504]);

function detailOf(body) {
  try {
    return JSON.parse(body)?.detail;
  } catch (error) {
    if (error instanceof SyntaxError) return undefined;
    throw error;
  }
}

// A download is fetched as a blob, so a refusal's JSON body arrives unread. A proxy's page or a validation error's list
// is no reason a person can read: null, as for any other failure.
export async function refusalReason(error) {
  if (!TELLS_WHY.has(error.response?.status)) {
    return null;
  }
  const detail = detailOf(await error.response.data.text());
  return typeof detail === 'string' ? detail : null;
}
